export const defaultElements = [
    {
        id: 1,
        icon: "font",
        label: "Input",
        path: "Custom/Inputs/Input",
        colspan: "col-span-3",
        tipo: "string",
        props: {
            name: "",
            label: "Input",
        },
    },

    {
        id: 2,
        icon: "circle-dot",
        label: "Radio",
        path: "Custom/Inputs/Radio",
        colspan: "col-span-3",
        props: {
            name: "",
            label: "Radio",
        },
    },
    {
        id: 3,
        icon: "fa-square-check",
        label: "Checkbox",
        path: "Custom/Inputs/Checkbox",
        colspan: "col-span-3",
        tipo: "boolean",
        props: {
            name: "",
            label: "Checkbox",
        },
    },
    // {
    //     id: 4,
    //     icon: 'align-center',
    //     label: 'Texto (descrição)',
    //     colspan: 'col-span-3',
    // },
    {
        id: 5,
        icon: "circle-chevron-down",
        label: "Select (combobox)",
        path: "Custom/Inputs/Select",
        colspan: "col-span-3",
        props: {
            name: "",
            label: "Select",
        },
    },
    {
        id: 6,
        icon: "calendar",
        label: "DatePicker",
        path: "Custom/Inputs/DatePicker",
        colspan: "col-span-3",
        props: {
            name: "",
            label: "DatePicker",
        },
    },
    // {
    //     id: 7,
    //     icon: 'divide',
    //     label: 'Divisor',
    //     colspan: 'col-span-12'
    // },
    {
        id: 8,
        icon: "file-arrow-up",
        label: "Upload de arquivo",
        colspan: "col-span-3",
        tipo: "file",
        props: {
            name: "",
            label: "File",
        },
    },
    // {
    //     id: 9,
    //     icon: 'cancel',
    //     label: 'Vazio',
    //     colspan: 'col-span-3',
    // },
    {
        id: 10,
        icon: 'toggle-off',
        label: 'Switch',
        colspan: 'col-span-3',
        tipo: "switch",
        path: "Custom/Inputs/Switch",
        props:{
            false: {
                label: '',
                value: false
            },
            true: {
                label: '',
                value: true,
            },
            size: {
                default: 'md'
            },
            refPointer: {
                default: null
            }
        }
    },
    // {
    //     id: 11,
    //     icon: 'diagram-successor',
    //     label: 'Aba',
    //     colspan: 'col-span-3',
    // },
    // {
    //     id: 12,
    //     icon: 'table-cells',
    //     label: 'Seção',
    //     colspan: 'col-span-3',
    // },
];

export const maxGridCols = 12;

export const gridColumnsOptions = [
    {
        label: "1",
        value: 1,
    },
    {
        label: "2",
        value: 2,
    },
    {
        label: "3",
        value: 3,
    },
    {
        label: "4",
        value: 4,
    },
    {
        label: "5",
        value: 5,
    },
    {
        label: "6",
        value: 6,
    },
    {
        label: "7",
        value: 7,
    },
    {
        label: "8",
        value: 8,
    },
    {
        label: "9",
        value: 9,
    },
    {
        label: "10",
        value: 10,
    },
    {
        label: "11",
        value: 11,
    },
    {
        label: "12",
        value: 12,
    },
];

export const componentOptions = [
    {
        label: "Select",
        value: "Custom/Inputs/Select",
    },
    {
        label: "Radio",
        value: "Custom/Inputs/Radio",
    },
    {
        label: "Input",
        value: "Custom/Inputs/Input",
    },
    {
        label: "DatePicker",
        value: "Custom/Inputs/DatePicker",
    },
    {
        label: "TextArea",
        value: "Custom/Inputs/TextArea",
    },
    {
        label: "File",
        value: "Custom/Inputs/File",
    },
    {
        label: "Checkbox",
        value: "Custom/Inputs/Checkbox",
    },
];



export const headingsType = [
    {
        label: "Comum",
        value: "comum",
    },
    {
        label: "Component",
        value: "component",
    },
    {
        label: "Data/Hora",
        value: "date",
    },
];

export const columnOptions = gridColumnsOptions.map(({ label, value }) => ({
    label,
    value: "col-span-" + value,
}));

export const tableComponentsOptions = [
    {
        label: "Máscara",
        value: "Custom/Show/Mask",
    },
    {
        label: "Options",
        value: "Custom/Show/Options",
    },
    {
        label: "Ativo",
        value: "Custom/Show/Ativo",
    },
    {
        label: "DiffDays",
        value: "DiffDays"
    },
    {
        label: "StatusPendencia",
        value: "BaseUnificada/StatusPendencia"
    }
];

export const modulos = [
    {
        label: "Protocolos",
        type: "button",
        value: route("osxwebs.index"),
        menu: "protocolos",
    },
    {
        label: "Projetos",
        type: "button",
        value: route("demands.index"),
        menu: "projetos",
    },
    // { 
    //     label: "Financeiro" ,
    //     type: "button",
    //     value: route("financeiro" ,
    // menu: "financeiro",

    

    // },
    // { 
    //     label: "Frotas" ,
    //     type: "button",
    //     value: route("frotas" ,
    // menu: "frotas",
// 

    // },
    { 
        label: "Documentações" ,
        type: "link",
        value: route('larecipe.index') ,

    },
    { 
        label: "Tickets",
        type: "button",
        value: route("tickets.index"),
    menu: "tickets",


    },
];

